/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from "../../store/index";
import TaskAddEditModal from "./TaskAddEditModal.vue";
import CraVisitTypeAddEditModal from "./CraVisitTypeAddEditModal.vue";

export default {
  name: "TaskQuestionLayout",
  components: { TaskAddEditModal, CraVisitTypeAddEditModal },


  data() {
    return {
      visits: [],
      baseurl: process.env.VUE_APP_Service_URL,
      selectedVisit: null,
      tasks: [],
      showTaskModal: false,
      editTaskData: null,
      checklists: [],
      checklist: [],
      selectedStudy: null,
      showVisitModal: false,
      editVisitId: null,
      showVisitMenu: {}
    };
  },
  mounted() {
    window.addEventListener("studyIdChanged", async () => {
      const currentstudy = store.getters.getStudyIs;
      this.selectedStudy = currentstudy;
      this.getVisitTypes();
    });
    this.selectedStudy = store.getters.getStudyIs;
    this.getVisitTypes();
  },

  methods: {

    addVisit() {
      this.showVisitModal = true;
      this.editVisitId = null;
    },
    toggleVisitMenu(index) {
      this.showVisitMenu[index] = !this.showVisitMenu[index];
    },

    closeVisitMenu(index) {
      this.showVisitMenu[index] = false;
    },

    closeAllVisitMenus() {
      this.showVisitMenu = {};
    },

    editVisit(visit) {
      this.editVisitId = visit.id;
      this.showVisitModal = true;
      this.closeAllVisitMenus();
    },


    async deleteVisit(visit) {
      if (!confirm("Are you sure you want to delete this visit type?")) return;

      const token = store.getters.getIdToken;

      try {
        await axios.delete(
          `${this.baseurl}/forms/cra/deletecravisittype?id=${visit.id}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        alert("Visit type deleted successfully");
        await this.getVisitTypes();
        this.closeAllVisitMenus();

      } catch (err) {
        console.error(err);
        alert("Failed to delete visit type");
      }
    },

    closeVisitModal() {
      this.showVisitModal = false;
      this.getVisitTypes();
    },
    async onVisitTypeSaved() {
      this.showVisitModal = false;
      await this.getVisitTypes();
    },

    addTask(selectedVisit) {
      this.showTaskModal = true;
      this.editTaskData = null;

    },

    editTask(task) {
      this.showTaskModal = true;
      this.editTaskData = task;

    },
    async getVisitTypes() {
      let token = store.getters.getIdToken;
      const res = await axios.get(
        `${this.baseurl}/forms/cra/getcravisittype?StudyId=${this.selectedStudy}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      this.visits = res.data || [];
    },
    async selectVisit(visit) {
      this.selectedVisit = visit;

      const studyId = store.getters.getStudyIs;
      const token = store.getters.getIdToken;

      this.tasks = [];

      const res = await axios.get(
        `${this.baseurl}/forms/cra/getchecklistbyvisit`,
        {
          params: {
            visitId: visit.id,
            studyId
          },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const templateId = res.data?.id;

      this.tasks = (res.data?.checklist || []).map(item => ({
        id: item.checklistId,
        name: item.title,
        questionCount: item.questions?.length || 0,
        questions: item.questions,
        craChecklistTempId: templateId
      }));
    },


    async onChecklistSaved() {
      this.showTaskModal = false;
      await this.selectVisit(this.selectedVisit);
    },
    async closeTaskModal() {
      this.showTaskModal = false;
      this.selectVisit(this.selectedVisit);
    },
    async deleteTask(task) {
      const token = store.getters.getIdToken;

      try {
        if (!confirm("Are you sure you want to delete this checklist?")) return;

        await axios.delete(
          `${this.baseurl}/forms/cra/deletecrachecklisttemp`,
          {
            data: {
              studyId: this.selectedStudy,
              visitTypeId: this.selectedVisit.id,
              checklistId: task.id,
              deleteAllQuestions: false
            },
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        alert("Checklist deleted successfully");
        await this.selectVisit(this.selectedVisit);
      } catch (err) {
        console.error(err);
        alert("Failed to delete checklist");
      }
    }

  }
}
